import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "mx-0 pb-[40px] mb-5 w-full bg-white relative md:rounded md:shadow-lg md:mx-auto max-w-[784px]",
  "data-tooltip-wrapper": ""
}
const _hoisted_2 = {
  key: 0,
  class: "w-full h-full absolute bg-curtain-color z-[100]"
}
const _hoisted_3 = { class: "max-w-[100vw] pt-6 px-4 md:pt-8 md:px-10" }

import FormHeader from '@/components/FormHeader/FormHeader.vue';
import { IFormStep } from '@/interfaces';
import loadingData from '@/assets/animated-icons/Loading_spinner_blue.json';
import { DotLottieVue } from '@lottiefiles/dotlottie-vue';
import { watch } from 'vue';
import { useFormStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'FormStep',
  props: {
    step: {},
    stepIndex: {}
  },
  setup(__props: any) {

const loadingIconData = loadingData as any;

// Define props and state
// ------------------------------------------------------------- //
const props = __props;

const formStore = useFormStore();

watch(
  () => props.step.isActive,
  async (newValue) => {
    if (newValue) {
      formStore.focusFirstTabbableAfterRender();
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.step.isLoading || _ctx.step.isMasked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.step.isLoading)
            ? (_openBlock(), _createBlock(_unref(DotLottieVue), {
                key: 0,
                autoplay: "",
                class: "absolute top-[50%] left-[50%] translate-y-[-50%] translate-x-[-50%]",
                style: {"width":"50px","height":"50px"},
                loop: "",
                data: _unref(loadingIconData)
              }, null, 8, ["data"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "header", {}, () => [
      _createElementVNode("div", null, [
        _createVNode(FormHeader, {
          step: _ctx.step,
          stepIndex: _ctx.stepIndex || 0
        }, null, 8, ["step", "stepIndex"])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})